import React from 'react';
import { Wrench, Clock, Mail } from 'lucide-react';
import { useData } from '../context/DataContext';

const Maintenance: React.FC = () => {
    const { settings } = useData();

    return (
        <div className="min-h-screen bg-neutral-900 flex items-center justify-center p-4">
            <div className="max-w-md w-full text-center space-y-8">
                {/* Logo/Icon */}
                <div className="flex justify-center mb-8">
                    <div className="relative">
                        <div className="absolute -inset-4 bg-automax-red/20 rounded-full blur-xl animate-pulse"></div>
                        <div className="bg-neutral-800 p-6 rounded-full relative z-10 border border-neutral-700">
                            <Wrench size={48} className="text-automax-red animate-spin-slow" />
                        </div>
                    </div>
                </div>

                {/* Content */}
                <div className="space-y-4">
                    <h1 className="text-4xl font-display font-bold text-white tracking-wider">
                        {settings.maintenanceTitle || 'UNDER MAINTENANCE'}
                    </h1>
                    <p className="text-gray-400 text-lg leading-relaxed">
                        {settings.maintenanceMessage || 'We are currently upgrading our system to serve you better. Please check back shortly.'}
                    </p>
                </div>

                {/* Expected Return */}
                <div className="bg-neutral-800/50 border border-neutral-800 rounded-lg p-6 flex items-center justify-center gap-4">
                    <Clock className="text-automax-red" size={24} />
                    <div className="text-left">
                        <p className="text-xs text-gray-500 uppercase tracking-wider font-bold">Estimated Return</p>
                        <p className="text-white font-medium">{settings.maintenanceEstimatedTime || 'Within 2 hours'}</p>
                    </div>
                </div>

                {/* Contact Info */}
                <div className="pt-8 border-t border-neutral-800">
                    <div className="flex items-center justify-center gap-2 text-gray-500 hover:text-white transition-colors">
                        <Mail size={16} />
                        <a href={`mailto:${settings.maintenanceEmail || settings.email || 'info@automax.co.tz'}`} className="text-sm">
                            {settings.maintenanceEmail || settings.email || 'info@automax.co.tz'}
                        </a>
                    </div>
                </div>
            </div>

            <style>{`
        @keyframes spin-slow {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .animate-spin-slow {
          animation: spin-slow 10s linear infinite;
        }
      `}</style>
        </div>
    );
};

export default Maintenance;
